import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequestWithRetry } from '@atlassian/jira-fetch';
import { GET_ME_URL } from './constants';
import type { AccountInfoResponse } from './types';

export const getAtlassianAccount = async (): Promise<AccountInfoResponse | null> => {
	try {
		const response = await performGetRequestWithRetry(GET_ME_URL);
		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getAtlassianAccount',
				packageName: 'jiraIssueViewServices',
				// eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
				teamName: 'jlove-makkuro',
			},
			error,
		});

		return null;
	}
};
